// extracted by mini-css-extract-plugin
export default {"principal":"Processos_principal__Hd8U8","container":"Processos_container__VZqUx"};